module.exports = __webpack_public_path__ + "static/media/marketing.fb392324.png";